import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentFailureIcon from "../../assets/img/Transaction-Declined.svg";
import User from "../../services/user.service";
import Storage from '../../services/storage.service';
import DownloadAppLinks from '../../ui/download_app_links';
import Settings from '../../services/settings.service';
import SpinnerTimeLoader from '../shared/timeLoading';

const subscriptions = [];
const PaymentFailure = props => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [error, setError] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loader, setLoader] = useState(false);
    console.log("error===>", error, errorMsg)
    useEffect(() => {
        setLoader(true);
        Storage.get_obsrv("paymentErrorCode").subscribe(data => {
            setError(data);
            let err = data ? data.toString().replace('-', '_') : "";
            setErrorMsg("error" + err);
        });

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )
        setLoader(false);
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const paymentHandling = () => {
        setLoader(true);
        Storage.clear("paymentFailedError");
        User.fetchFlowStatus().then(() => {
            setLoader(false);
            window.location.href = "/join/#/pay/";
        }).catch(() => {
            setLoader(false);
            Storage.clear("paymentFailedError");
            window.location.reload();
        });
    }

    return (<div className="payment-summary-main summary-main">
        {loader ? <SpinnerTimeLoader /> :
            <div className="summary-wrapper">
                <div className="summary-right-col">
                    <div className="payment-summary-failure">
                        <div>
                            <img src={PaymentFailureIcon} alt={translationKeys["kw_payment_not_completed"]}></img>
                        </div>
                        <div className='payment-success-title'>
                            {translationKeys["kw_payment_not_completed"]}
                        </div>
                        <div className='payment-success-desc'>
                            {translationKeys["kw_payment_failure_desc"]}<br />
                            {translationKeys["kw_payment_failure_sub_desc"]}
                        </div>
                        <div className="buttons-confirm success-continue" >
                            <button className="pay_now_btn" onClick={paymentHandling}> {translationKeys["kw_retry_btn"]}</button>
                        </div>
                        <p className='download-app'>{translationKeys["kw_payment_download_app"]}</p>
                        <DownloadAppLinks
                            classes={"download-app-container-btns-area"}
                            google_play_link={Settings.ob_google_play}
                            app_store_link={Settings.ob_app_store}
                            huawei_store_link={Settings.ob_app_gallery}
                        />
                    </div>
                </div>
            </div>
        }
    </div>
    )
}

export default PaymentFailure;